module.exports = __webpack_public_path__ + "static/media/auto-card.62db8820.png";